// 网址操作工具类
export class UrlHandler {

    // 获取传递进来的url字符串中的指定参数
    public static getUrlParam(url: string, paramKey: string): string | null {
        const urlObj = new URL(url);
        return urlObj.searchParams.get(paramKey) || null;
    }

    // 清除当前网址中指定的参数
    public static removeCurrentUrlParam(paramKey: string): void {
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        searchParams.delete(paramKey);
        window.history.replaceState(null, '', `${currentUrl.pathname}?${searchParams.toString()}`);
    }

    // 获取当前网址的指定参数
    public static getCurrentUrlParam(paramKey: string): string | null {
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        return searchParams.get(paramKey);
    }

    // 设置当前网址的指定param
    public static setCurrentUrlParam(paramKey: string, paramValue: string) {
        // 解析当前URL
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        // 删除已存在的参数
        if (searchParams.has(paramKey)) {
            searchParams.delete(paramKey);
        }
        // 添加新的参数
        searchParams.set(paramKey, paramValue);
        // 更新URL的查询部分
        currentUrl.search = searchParams.toString();

        // 使用history API替换当前URL，不刷新页面
        window.history.replaceState(null, document.title, currentUrl.href);
    }

    // 设置当前网址的指定param并返回网址，不变更浏览器中的网址
    public static setCurrentUrlParamAndReturnUrl(paramKey: string, paramValue: string):string {
        // 解析当前URL
        const currentUrl = new URL(window.location.href);
        const searchParams = new URLSearchParams(currentUrl.search);
        // 删除已存在的参数
        if (searchParams.has(paramKey)) {
            searchParams.delete(paramKey);
        }
        // 添加新的参数
        searchParams.set(paramKey, paramValue);
        // 更新URL的查询部分
        currentUrl.search = searchParams.toString();

        return currentUrl.href
    }
}